export function containerFrom(size: number, name?: string): string {
	const containerName = name ? `${name} ` : '';

	return `@container ${containerName}(min-width: ${size}px)`;
}

export function containerUpTo(size: number, name?: string): string {
	const containerName = name ? `${name} ` : '';

	return `@container ${containerName}(max-width: ${size}px)`;
}

// Container queries are supported in the most recent versions of all modern browsers.
// The only exception is Safari 15. This query can be used to create a fallback.
export const containerNotSupported = '@supports not (container-type: inline-size)';
